export default __webpack_public_path__ + "01e8f15e899155c68950c40e0a6b8df0.png";